import { Injectable } from '@angular/core';
import { CompatibleVehicle, ProductData } from '../pages/official-website/ecat/models/product.interface';
import { Observable, delay, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor() { }

  getProductById(id: number): Observable<ProductData> {
    // 模拟API调用
    const mockData: ProductData = {
      id,
      code: "096A47-4602",
      name: "滤清器名称滤清器名称滤清器名称",
      specifications: ["适用车型系列：096A47-4602", "适用车型系列：096A47-4602"],
      brand: "上汽",
      productCodes: "1ED619644/1ED619653/1/1ED819644",
      quantity: 1824,
      minumQty: 1,
      stockQty: 1000,
      expectedDate: "2024-07-01",
      inventory: "充足",
      images: [
        "https://via.placeholder.com/400x400?text=Product+Image+1",
        "https://via.placeholder.com/400x400?text=Product+Image+2",
        "https://via.placeholder.com/400x400?text=Product+Image+3",
        "https://via.placeholder.com/400x400?text=Product+Image+4",
        "https://via.placeholder.com/400x400?text=Product+Image+4",
        "https://via.placeholder.com/400x400?text=Product+Image+4",
        "https://via.placeholder.com/400x400?text=Product+Image+4",
      ],
      technicalParams: {
        "直径(含包装)": "175 mm",
        螺纹介质: "2",
        过滤器材质: "合成聚氨酯滤",
        "长度(含包装)": "361 mm",
        "高度(含包装)": "30 mm",
      },
      compatibleVehicles: Array.from({ length: 10 }, (_, i) => ({
        brand: "大众",
        series: "ID.3",
        model: "进口版",
        displacement: "电动",
        year: "2024",
        salesData: "ID.3",
        engineModel: "EDN(电动机组)",
        compatibilityNotes: "安装要求高(汽车型)",
        remarks: "20250521",
      })),
    }

    return of(mockData).pipe(delay(500))
  }

  getAllCompatibleVehicles(productCode: string): Observable<CompatibleVehicle[]> {
    const mockVehicles: CompatibleVehicle[] = [
      {
        brand: "AMG",
        series: "AMG GT",
        model: "3.0T 手自一体",
        displacement: "3.0",
        year: "2023",
        salesData: "AMG GT 50 48V",
        engineModel: "256 930",
        compatibilityNotes: "空调滤清器(单效)",
        remarks: "",
      },
      {
        brand: "AMG",
        series: "AMG GT",
        model: "3.0T 手自一体",
        displacement: "3.0",
        year: "2023",
        salesData: "AMG GT 50 4MATIC+ 48V",
        engineModel: "256 930",
        compatibilityNotes: "空调滤清器(单效)",
        remarks: "",
      },
      {
        brand: "AMG",
        series: "AMG GT",
        model: "3.0T 手自一体",
        displacement: "3.0",
        year: "2024",
        salesData: "AMG GT 53 4MATIC+ 48V",
        engineModel: "",
        compatibilityNotes: "空调滤清器(单效)",
        remarks: "",
      },
      {
        brand: "AMG",
        series: "AMG GT",
        model: "3.0T 手自一体",
        displacement: "3.0",
        year: "2022",
        salesData: "AMG GT 53 4MATIC+ 48V",
        engineModel: "256 930",
        compatibilityNotes: "空调滤清器(单效)",
        remarks: "",
      },
      {
        brand: "AMG",
        series: "AMG GT",
        model: "4.0T 手自一体",
        displacement: "4.0",
        year: "2019",
        salesData: "AMG GT 63 S 4MATIC+",
        engineModel: "177 980",
        compatibilityNotes: "空调滤清器(单效)",
        remarks: "",
      },
    ]

    return of(mockVehicles).pipe(delay(300))
  }

  submitErrorReport(errorReport: any): Observable<any> {
    console.log("Error report submitted:", errorReport)
    return of({ success: true }).pipe(delay(1000))
  }
}
